import React from 'react';
import lm001 from '../images/challenge2013/lm.001.png';
import lm002 from '../images/challenge2013/lm.002.png';
import lm003 from '../images/challenge2013/lm.003.png';
import lm004 from '../images/challenge2013/lm.004.png';
import lm005 from '../images/challenge2013/lm.005.png';
import lm006 from '../images/challenge2013/lm.006.png';
import lm007 from '../images/challenge2013/lm.007.png';
import lm008 from '../images/challenge2013/lm.008.png';

import epflLogo from '../stylesheets/svg/epfl-logo.svg';
import cgrLogo from '../images/logo/cgr-logo-150.png';
import kaistLogo from '../images/logo/kaist-logo-150.png';
import mmLogo from '../images/logo/micromanager-logo-150.png';
import lebLogo from '../images/logo/leb-logo-150.png';
import hamLogo from '../images/logo/hamamatsu-logo-150.png';
import mclLogo from '../images/logo/mcl-logo-150.jpg';
import obiaLogo from '../images/logo/obia-logo-150.png';
import eurobioLogo from '../images/logo/eurobioimaging-logo-150.png';
import logoPalmSevier from '../images/logo/logo-palm-siever.png';

import closeUp1 from '../images/challenge2013/closeup-1.png';
import closeUp2 from '../images/challenge2013/closeup-2.png';
import closeUp3 from '../images/challenge2013/closeup-3.png';
import secA1LS from '../images/challenge2013/section-A-1_LS.png';
import secB1LS from '../images/challenge2013/section-B-1_LS.png';
import profA1LS from '../images/challenge2013/profile-A-1_LS.png';
import profB1LS from '../images/challenge2013/profile-B-1_LS.png';
import chartClosest from '../images/challenge2013/chart-closest-distribution-1_LS.png';
import charSNR from '../images/challenge2013/chart-snr-distribution-1_LS.png';
import tubulins from '../images/tubulins.gif';
import screenshotPalmSevier from '../images/challenge2013/screenshot-palm-siever.png';
import { Link } from 'react-router-dom';

class Challenge2013 extends React.Component {
    constructor(props) {
        super(props)
        this.state = {"subpage":"Method"} // "Method" or "Results" or "Organization"
        this.renderMethod.bind(this);
        this.renderResults.bind(this);
        this.renderOrganization.bind(this);
    }
    renderResults () {
        return (
            <div>
                <h3>Results</h3>
                <p>
                </p>
        
                <div id="group1_large">

                    <h4>Publication of the results in the Nature Methods article</h4>
                    <p>
                    D. Sage, H. Kirshner, T. Pengo, N. Stuurman, J. Min, S. Manley & M. Unser, 
                    <a href="http://www.nature.com/nmeth/journal/v12/n8/full/nmeth.3442.html">Quantitative evaluation of software packages for single-molecule localization microscopy</a>, Nature Methods <b>12</b>, 717–724 (2015).
                    </p>
                    <span className="readmore"><a href="http://bigwww.epfl.ch/publications/sage1501.pdf">Read full PDF</a></span>
    
                </div>
                <div id="group1_large">

                    <h6>Results of a software</h6>
                    <p>
                    The detailled results of the evaluation for a specific software 
                    has been communicated to the the participants for every submitted localization files 
                    corresponding to a dataset. It is included the full statistical analysis, some rendering images, 
                    some comparative rendering image (tested software localization vs ground-truth), and 
                    some cross-section profiles.
                    </p>

                    <h4>Example of comparitive close-ups</h4>
                    <p>
                    Rendering images by sum up of 2D Gaussian functions. The composite color image cobimes
                    red channel (Ground-truth localizations) and the green channel (tested software localizations).
                    </p>
    

                    
                        <table className="table">
                            <tbody>
                            <tr>
                                <td><img src={closeUp1} className="frame"/></td>
                                <td><img src={closeUp2} className="frame"/></td>
                                <td><img src={closeUp3} className="frame"/></td>
                            </tr>
                            <tr>
                            <td style={{"textAlign":"center"}}>
                            Scale bar: 4400 nm<br></br>
                            Rendering pixelsize: 44 nm/pixel
                            </td><td style={{"textAlign":"center"}}>
                            Scale bar: 400 nm<br></br>
                            Rendering pixelsize: 4 nm/pixel
                            </td><td style={{"textAlign":"center"}}>
                            Scale bar: 100 nm<br></br>
                            Rendering pixelsize: 1 nm/pixel
                            </td></tr>
                            </tbody>
                        </table>
                    

                
                        <h4>Example of cross-section</h4>
                        <p>
                        Rendering images by sum up of 2D Gaussian functions. The composite color image cobimes
                        red channel (Ground-truth localizations) and the green channel (tested software localizations).
                        </p>
                        <table>
                            <tbody>
                            <tr ><td valign="top"><img src={secA1LS} className="frame"/></td><td><img src={profA1LS}/></td></tr>
                            <tr ><td valign="top"><img src={secB1LS} className="frame"/></td><td><img src={profB1LS}/></td></tr>
                            </tbody>
                        </table>

                        
                        <h4>Detections in function of the local SNR</h4>
                        <img src={charSNR}/>
                        

                        
                            <h4>Detections in function of the closest distance</h4>

                            <img src={chartClosest}/>
                        
                    
                </div>
                <div id="group1_large">

                    <h6>Java tool for evaluation</h6>

                    
                        <h4 style={{"clear":"both"}}>CompareLocalization: Java application</h4>
                        <img src="http://bigwww.epfl.ch/smlm/evaluation/comparelocalization.png" style={{"float":"right", "width":"480px"}}/>
                        <p >
                        A Java application to compare two sets of localization is given at <a href="http://bigwww.epfl.ch/smlm/tools/CompareLocalization.jar">CompareLocalization.jar</a>.
                        The positions of the molecules have to be stored in a column-separated text file, as CSV file. Information to parse this 
                        file has to provided in a XML <a href="http://bigwww.epfl.ch/smlm/methods/index.html?p=metrics">description file</a>
                        or provided using the graphical user interface. 
                        A tool to create the XML file <a href="http://bigwww.epfl.ch/smlm/methods/index.html?p=metrics">available</a>
                        </p>
                        <p>Examples</p>
                        
                        <ul>
                            <li><a href="http://bigwww.epfl.ch/smlm/tools/groundtruth/file-description.xml">file-description.xml</a> to parse Ground-truth file</li>
                            <li><a href="http://bigwww.epfl.ch/smlm/tools/quickpalm/file-description.xml">file-description.xml</a> to parse QuickPALM file</li>
                            <li><a href="http://bigwww.epfl.ch/smlm/tools/rapidstorm/file-description.xml">file-description.xml</a> to parse RapidSTORM file</li>
                            <li><a href="http://bigwww.epfl.ch/smlm/tools/m2le/file-description.xml">file-description.xml</a> to parse M2LE file</li>
                        </ul>
                    
                    <p>
                    This application can run on any machine with at least <a href="http://www.java.com/">Java 1.5</a> installed.
                    </p>
                </div>
            </div>
        )
    }


    renderOrganization () {
        let title = ["Introduction","PSF models","Photon quantification","Datasets","Rendering","File format","Assessment","B-recs","FacePALM","FALCON","Fast-ML-HD","FPGA","GPUgaussMLE","Insight3","MicroManager LM","QuickPALM","RadialSymmetry","simpleSTORM","SOSplugin","ThunderSTORM","Wavelet FluoroBrancroft","Additional software (a-livePALM, DOASTORM, PeakFit, RapidSTORM)","Results - Real datasets","Results - Localization","Round-table, discussions"]
        let name = ["Daniel Sage","Hagai Kirshner","Nico Stuurman","Daniel Sage","Thomas Pengo","Nico Stuurman","Daniel Sage","Herveé Raoult","Eelco Hoogendoorn","Junhong Min","Kyungsang Kim","Manfred Kirchgessner","Keith Lidke","Ryan McGorty","Nico Stuurman","Christophe Zimmer","Raghuveer Parthasarathy","Luca Fiaschi","Ihor Smal","Pavel Krizek","Trevor Ashley","Thomas Pengo","Junhong Min","Thomas Pengo","Everybody"]
    
        return (
            <div>
                <h3>Goals of the challenge</h3>

                <p className="justify">
                    The goal of this challenge is to benchmark currently available localization software. 
                    In particular, comparing their performance in terms of detection rate, localization accuracy, and image rendering. 
                    Accessibility, usability for the end-user, and computational time will be evaluated, too. 
                    The benchmark data consists of simulated images of various biological structure such as tubulins. 
                    The simulated data accounts for fluorophores activation and excitation, image formation, and 
                    known perturbations models. As the ground truth exact positions of the fluorophores are known, 
                    the benchmarking metrics will use use objective measures.	
                </p>
                <ul>
                    <li style={{"padding":"0px"}}>Provide reference datasets</li>
                    <li style={{"padding":"0px"}}>Establish of a metrics</li>
                    <li style={{"padding":"0px"}}>Gather information about the available software</li>
                    <li style={{"padding":"0px"}}>Identify of the new directions</li>
                </ul>

                <p className="justify">
                    The challenge is open to all individuals or teams, academic or corporate, existing or newly developed localization microscopy software.
                    Participation is free.
                </p>
                <p className="justify">
                    To announce your participation, send  
                    <a href="mailto:daniel.sage@epfl.ch?subject=Pre-registration to Localization Microscopy Challenge&body=Please, indicate the name of the software and the name of the contact person.">email</a> indicating the <b>name 
                    of the software</b> that you want to represent or to test and the <b>name of a contact</b> person.
                    This pre-registration gives access to the ground-truth of the training datasets. 

                </p>


                <div id="group1_large">

                    <h3>IEEE ISBI Workshop</h3>
                    <h7>April, 8, 2013, San Francisco</h7>

                    <table>
                        <tr>
                        <td>
                            <table width="100%" className="report_table" style={{"border":"0px"}}>

                                <tr>
                                <td className="report_header" >Presentation</td>
                                <td className="report_header" nowrap>Speaker</td>
                                </tr>
                                
                                {
                                title.map((t,i) => {
                                    return (
                                    <tr><td className="report_params">{t}</td><td className="report_params" style={{"padding":"3px"}}>{name[i]}</td></tr>
                                    )
                                })
                                }

                            </table>
                        </td>
                            <td style={{"width":"20px"}}></td>
                            <td>
                                <img src="picture-presentation-1.png" style={{"width":"300px"}} className="frame"/><br></br>  
                                <img src="picture-presentation-2.png" style={{"width":"300px"}} className="frame"/><br></br>                          
                                <img src="picture-workshop.png" style={{"width":"300px"}} className="frame"/><br></br>  
                            </td>
                        </tr>
                    </table>
                </div>

                <div id="group1_large">

                <table style={{"width":"100%"}}>

                    <tr><td colspan="2">
                    <h3>Committee &bull; Challenge 2013</h3>
                    </td></tr>
                    <tr><td style={{"width":"49%"}}>
                    <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="http://bigwww.epfl.ch/sage/" /><img src={epflLogo} style={{"width":"100px"}} className="frame"/></div>
                    <p style={{"font-family":"Times New Roman","font-size":"16px"}}><a href="http://bigwww.epfl.ch/sage/" target="_new" style={{"color":"black"}}>Daniel Sage</a></p>
                    <p><a href="mailto:daniel.sage@epfl.ch?subject=Localization Microscopy Challenge">daniel.sage@epfl.ch</a></p>
                    <p>Biomedical Imaging Group (BIG)<br></br> Ecole Polytechnique Fédérale de Lausanne (EPFL)</p>
                    <div style={{"clear":"both","height":"30px"}}></div>
                    </td><td style={{"width":"49%"}}>	
                    <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="http://bigwww.epfl.ch/kirshner/"><img src={epflLogo} style={{"width":"100px"}} className="frame" /></a></div>
                    <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="http://bigwww.epfl.ch/" target="_new" style={{"color":"black"}}>Hagai Kirshner</a></p>
                    <p><a href="mailto:hagai.kirshner@epfl.ch?subject=Localization Microscopy Challenge">hagai.kirshner@epfl.ch</a></p>
                    <p>Biomedical Imaging Group (BIG)<br></br>Ecole Polytechnique Fédérale de Lausanne (EPFL)</p>
                    <div style={{"clear":"both","height":"30px"}}></div>
                    </td></tr><tr><td>
                    <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="http://www.crg.es/"><img src={cgrLogo} style={{"width":"100px"}} className="frame" /></a></div>
                    <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="http://www.crg.es/" target="_new" style={{"color":"black"}}>Thomas Pengo</a></p>
                    <p>Center for Genomic Regulation<br></br>Barcelona, Spain</p>
                    <div style={{"clear":"both","height":"30px"}}></div>
                    </td><td>	
                    <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="https://valelab.ucsf.edu/external/people/p-stuurman.htm"><img src={mmLogo} style={{"width":"100px"}} className="frame" /></a></div>
                    <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="https://valelab.ucsf.edu/external/people/p-stuurman.htm" target="_new"  style={{"color":"black"}}>Nico Stuurmann</a></p>
                    <p>Vale Lab<br></br>University of California, San Francisco (UCSF)</p>
                    <div style={{"clear":"both","height":"30px"}}></div>
                    </td></tr><tr><td>
                    <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="http://bispl.weebly.com"><img src={kaistLogo} style={{"width":"100px"}} className="frame" /></a></div>
                    <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="http://bispl.weebly.com" target="_new"  style={{"color":"black"}}>Junhong Min</a></p>
                    <p>Bio Imaging Signal Processing<br></br>Korea Advanced Institute of Sci. and Tech. (KAIST)</p>
                    <div style={{"clear":"both","height":"30px"}}></div>
                    </td><td>	
                    <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="http://leb.epfl.ch/"><img src={lebLogo} style={{"width":"100px"}} className="frame" /></a></div>
                    <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="http://leb.epfl.ch/" target="_new"  style={{"color":"black"}}>Suliana Manley</a></p>
                    <p>Laboratory of Experimental Biophysics (LEB)<br></br>Ecole Polytechnique Fédérale de Lausanne (EPFL)</p>
                    <div style={{"clear":"both","height":"30px"}}></div>
                    </td></tr>

                </table>

                </div>

                <div id="group1_large">

                    <table style={{"width":"100%"}}>

                        <tr><td colspan="2">
                        <h3>Sponsors &bull; Challenge 2013</h3>
                        </td></tr>
                        <tr><td width="50%">
                        <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="http://www.hamamatsucameras.com"><img src={hamLogo} style={{"width":"100px"}} className="frame"/></a></div>
                        <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="http://www.hamamatsucameras.com" target="_new" style={{"color":"black"}}>Hamamatsu, Camera Products</a></p>
                        <p><a href="http://www.hamamatsucameras.com">www.hamamatsucameras.com</a></p>
                        <div style={{"clear":"both","height":"30px"}}></div>
                        </td><td width="50%">	
                        <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="http://bigwww.epfl.ch/sage/"><img src={mclLogo} style={{"width":"100px"}} className="frame"/></a></div>
                        <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="http://www.madcitylabs.com" target="_new" style={{"color":"black"}}>Mad City Labs</a></p>
                        <p><a href="http://www.madcitylabs.com">www.madcitylabs.com</a></p>
                        <div style={{"clear":"both","height":"30px"}}></div>
                        </td></tr>
                        <tr><td>
                        <div style={{"float":"left","marging-right":"10px","height":"100px"}}><a href="http://www.eurobioimaging.eu"><img src={eurobioLogo} style={{"width":"100px"}} className="frame"/></a></div>
                        <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="http://www.eurobioimaging.eu" target="_new" style={{"color":"black"}}>Euro-BioImaging</a></p>
                        <p>Euro‐BioImaging is a large‐scale pan‐European research infrastructure project on the European Strategy Forum on Research Infrastructures (ESFRI) Roadmap. 
                        <a href="http://www.eurobioimaging.eu">www.eurobioimaging.eu</a></p>
                        <div style={{"clear":"both","height":"30px"}}></div>
                        </td><td>	
                        <div style={{"float":"left","marging-right":"10px","height":"80px"}}><a href="http://www.openbioimage.org/"><img src={obiaLogo} style={{"width":"100px"}} className="frame"/></a></div>
                        <p style={{"font-family":"Georgia, Times New Roman, Times, serif","font-size":"16px"}}><a href="http://www.openbioimage.org/" target="_new" style={{"color":"black"}}>Open Bio Image Alliance</a></p>
                        <p><a href="http://www.openbioimage.org">www.openbioimage.org</a></p>
                        <div style={{"clear":"both","height":"30px"}}></div>
                        </td></tr>

                    </table>

                </div>

            </div>
        )
    }


    renderMethod () {
        return (
            <div id="group1_large">

            <h3 >Methods</h3>
            <div style={{"display":"flex","flexWrap":"wrap","justifyContent":"space-between"}}>
            <p className="report_param" style={{"margin":"10px"}}>1. <a href="#1">Simulator</a></p>
            <p className="report_param" style={{"margin":"10px"}}>2. <a href="#2">Sample Factory</a></p>
            <p className="report_param" style={{"margin":"10px"}}>3. <a href="#3">Fluorophore Factory</a></p>
            <p className="report_param" style={{"margin":"10px"}}>4. <a href="#4">Image Formation Model</a> (PSF)</p>
            <p className="report_param" style={{"margin":"10px"}}>5. <a href="#1">Noise Model and Digitalization</a></p>
            <p className="report_param" style={{"margin":"10px"}}>6. <a href="#2">Metrics of asssessment</a></p>
            <p className="report_param" style={{"margin":"10px"}}>7. <a href="#3">Format</a></p>
            <p className="report_param" style={{"margin":"10px"}}>8. <a href="#4">Rendering</a></p>
            </div>

            <a name="1"></a><p style={{"height":"40px","clear":"both"}}></p>
            <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"21px"}}>1. Simulator</h1>
            <div id="group1_large">
                <img src={lm001} alt="simulation"/>
            </div>
            <a name="2"></a><p style={{"height":"40px","clear":"both"}}></p>
            <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"21px"}}>2. Sample Factory</h1>
            <div id="group1_large">
                <img src={lm002} className="shadowbox" alt="factory"/>
            </div>
            <a name="3"></a><p style={{"height":"40px","clear":"both"}}></p>
            <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"21px"}}>3. Fluorophore Factory</h1>
            <div id="group1_large">
                <img src={lm003} className="shadowbox" alt="factory"/>
            </div>
            <a name="4"></a><p style={{"height":"40px","clear":"both"}}></p>
            <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"21px"}}>4. Image Formation Model (PSF)</h1>
            <div id="group1_large">
                <img src={lm004} className="shadowbox" alt="psf"/>
            </div>
            <a name="5"></a><p style={{"height":"40px","clear":"both"}}></p>
            <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"21px"}}>5. Noise Model and Digitalization</h1>
            <div id="group1_large">
                <img src={lm005} className="shadowbox" alt="noise"/>
            </div>

            <a name="6"></a><p style={{"height":"40px","clear":"both"}}></p>
            <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"21px"}}>6. Metrics of asssement</h1>
            <div id="group1_large">

            <p>
            <img className="frame" src={lm007}/>
            </p>
            </div>

            <a name="7"></a><p style={{"height":"40px","clear":"both"}}></p>
            <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"21px"}}>7. Format</h1>
            <div id="group1_large">

            <h6>Towards standardization of the file format</h6>

                <img className="frame" src={lm006}></img>
            </div>


            <a name="8"></a><p style={{"height":"40px","clear":"both"}}></p>
            <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"21px"}}>8. Rendering</h1>
            <div id="group1_large">

                <h4>PALM-siever &bull; Visualization for Single-Molecule Localization Microscopy</h4>
                <div style={{"display":"flex","marginBottom":"20px"}}>
                    <div>
                        <a className="photo_hover2" href="http://code.google.com/p/palm-siever/">
                        <img src={logoPalmSevier} alt="palm-siever"/></a>
                    </div>
                    
                    <p className="justify">
                        For this challenge, we use <a href="http://code.google.com/p/palm-siever/" target="_blank"> PALM-siever</a> as tool 
                        to render the reconstruction image from the localization results. 
                        <a href="http://code.google.com/p/palm-siever/" target="_blank"> PALM-siever </a> is hosted by Google Project. <br></br>
                        The PALM-siever platform covers both visualization and analysis of single-molecule localization 
                        microscopy data. Built on MATLAB, it enables data to be modified and displayed interactively.
                    </p>
                </div>
                <div style={{"display":"flex"}}>
                    <div style={{"marginRight":"40px"}}>
                        <h4 style={{"clear":"both"}}>Features</h4>
                        <ul>
                            <li>histogram, smoothed histogram, scatter, delaunay, color-coded 3D</li>
                            <li>smart import of tabular data</li>
                            <li>interactive slicing with any variable</li>
                            <li>plugins</li>
                        </ul>
                    </div>

                    <div style={{"margin":"20px","textAlign":"center"}}>
                        <img src={screenshotPalmSevier} alt="palm-siever"/>
                    </div>
                </div>
            </div>
        </div>
        )
    }

    render() {
        return (
        <div>
            <div>
                <div>
                <h1 style={{"marginLeft":"0px","padding":"0","fontSize":"40px"}}>Challenge 2D &bull; Theoretical PSF</h1>
                </div>
                <img src={tubulins}  alt="banner" style={{"float":"right","paddingLeft":"10px", "width":"300px"}}/>
                
                <p className="abstract" style={{"fontSize":"18px","margin":"10px"}}>
                    The Grand Challenge Localization Microscopy was presented as a <a href="#" onClick={() => this.setState({"subpage":"Organization"})}>Workshop</a> in IEEE conference <a href="http://www.biomedicalimaging.org/2013/program/isbi-challenges/"> ISBI </a>.
                    Nearly 30 <a href="http://srm.test.ch/SoftwareList" target="_blank" > softwares </a> have been run, mostly by the authors of the software, thus constituting 
                    the first world-wide effort in benchmarking the localization software in a comprehensive review.
                    <br></br><br></br>
                    The results are in the paper: Sage et al. <a href="https://www.nature.com/articles/nmeth.3442" target="_blank">Quantitative evaluation of software packages for SMLM</a>, Nature Methods 12, 2015.
                </p>
            
          
                <hr></hr>
                <div style={{"display":"flex",flexWrap:"wrap"}}>
                    <button className="btn primary" onClick={() => this.setState({"subpage":"Method"})} style={{"margin":"2px"}}>Methods</button>
                    <button className="btn primary" onClick={() => this.setState({"subpage":"Organization"})} style={{"margin":"2px"}}>Organization</button>
                    <button className="btn primary" onClick={() => this.setState({"subpage":"Datasets"})} style={{"margin":"2px"}}>Datasets</button>
                    <button className="btn primary" onClick={() => this.props.history.push('/SoftwareList')} style={{"margin":"2px"}}>Participants</button>
                    <button className="btn primary" onClick={() => this.setState({"subpage":"Results"})} style={{"margin":"2px"}}>Results</button>
                </div>
                
            
            </div>
            <p style={{"height":"40px"}}></p>
            {this.state["subpage"] === "Method" && this.renderMethod()}
            {this.state["subpage"] === "Results" && this.renderResults()}
            {this.state["subpage"] === "Organization" && this.renderOrganization()}
            {this.state["subpage"] === "Datasets" && <p><Link to='/Challenge/ChallengeSimulatedData' >Link to datasets page </Link> </p>}
            
    </div>
      );
    }
}

export default Challenge2013;


